/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationDisciplineOrder } from './HomeHealthCertificationDisciplineOrder';
import {
    HomeHealthCertificationDisciplineOrderFromJSON,
    HomeHealthCertificationDisciplineOrderFromJSONTyped,
    HomeHealthCertificationDisciplineOrderToJSON,
    HomeHealthCertificationDisciplineOrderToJSONTyped,
} from './HomeHealthCertificationDisciplineOrder';

/**
 * 
 * @export
 * @interface HomeHealthCertificationReferralOrderDisciplines
 */
export interface HomeHealthCertificationReferralOrderDisciplines {
    /**
     * 
     */
    SN: HomeHealthCertificationDisciplineOrder;
    /**
     * 
     */
    PT: HomeHealthCertificationDisciplineOrder;
    /**
     * 
     */
    OT: HomeHealthCertificationDisciplineOrder;
    /**
     * 
     */
    SLP: HomeHealthCertificationDisciplineOrder;
    /**
     * 
     */
    MSW: HomeHealthCertificationDisciplineOrder;
    /**
     * 
     */
    HHA: HomeHealthCertificationDisciplineOrder;
}

/**
 * Check if a given object implements the HomeHealthCertificationReferralOrderDisciplines interface.
 */
export function instanceOfHomeHealthCertificationReferralOrderDisciplines(value: object): value is HomeHealthCertificationReferralOrderDisciplines {
    if (!('SN' in value) || value['SN'] === undefined) return false;
    if (!('PT' in value) || value['PT'] === undefined) return false;
    if (!('OT' in value) || value['OT'] === undefined) return false;
    if (!('SLP' in value) || value['SLP'] === undefined) return false;
    if (!('MSW' in value) || value['MSW'] === undefined) return false;
    if (!('HHA' in value) || value['HHA'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationReferralOrderDisciplinesFromJSON(json: any): HomeHealthCertificationReferralOrderDisciplines {
    return HomeHealthCertificationReferralOrderDisciplinesFromJSONTyped(json, false);
}

export function HomeHealthCertificationReferralOrderDisciplinesFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationReferralOrderDisciplines {
    if (json == null) {
        return json;
    }
    return {
        
        'SN': HomeHealthCertificationDisciplineOrderFromJSON(json['SN']),
        'PT': HomeHealthCertificationDisciplineOrderFromJSON(json['PT']),
        'OT': HomeHealthCertificationDisciplineOrderFromJSON(json['OT']),
        'SLP': HomeHealthCertificationDisciplineOrderFromJSON(json['SLP']),
        'MSW': HomeHealthCertificationDisciplineOrderFromJSON(json['MSW']),
        'HHA': HomeHealthCertificationDisciplineOrderFromJSON(json['HHA']),
    };
}

export function HomeHealthCertificationReferralOrderDisciplinesToJSON(json: any): HomeHealthCertificationReferralOrderDisciplines {
    return HomeHealthCertificationReferralOrderDisciplinesToJSONTyped(json, false);
}

export function HomeHealthCertificationReferralOrderDisciplinesToJSONTyped(value?: HomeHealthCertificationReferralOrderDisciplines | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SN': HomeHealthCertificationDisciplineOrderToJSON(value['SN']),
        'PT': HomeHealthCertificationDisciplineOrderToJSON(value['PT']),
        'OT': HomeHealthCertificationDisciplineOrderToJSON(value['OT']),
        'SLP': HomeHealthCertificationDisciplineOrderToJSON(value['SLP']),
        'MSW': HomeHealthCertificationDisciplineOrderToJSON(value['MSW']),
        'HHA': HomeHealthCertificationDisciplineOrderToJSON(value['HHA']),
    };
}

